import { Text, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { useBasketInfoResume } from '../../../../hooks/basketInfoResume';

interface BasketInfoResumeProps {}

export const BasketInfoResume: React.FC<BasketInfoResumeProps> = () => {
  const {
    fontVariant,
    isMobile,
    totalAmountFormatted,
    totalAvailableBalanceFormatted,
    totalCustomers,
    totalOffers,
    updatedDateFormatted,
    totalOffersByMarket,
  } = useBasketInfoResume();

  return (
    <VStack px={{ sm: Spacing['inline.xxs'] }} space={Spacing['inline.xxs']} flex={1} w="full">
      <Stack
        borderRadius={BoxRadius.sm}
        px={Spacing['inline.xxs']}
        py={Spacing['inline.xxxs']}
        bgColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}
        space={{ base: Spacing['stack.xxxs'] }}>
        <Stack
          space={Spacing['inline.nano']}
          direction="column"
          justifyContent="space-between"
          w={{ base: 'full', sm: 'container' }}>
          <Text variant={'semibold'} fontSize={Typography['fontsize.md']} color="neutral.darkest">
            Resumo de validação e investimentos
          </Text>
          <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.darkest">
            Confira a quantidade de clientes validados, saldos disponíveis e ativos adicionados
          </Text>
        </Stack>
        <Box h={0.3} w="full" bgColor={'neutral.lightest'} />
        <Stack
          direction={{ base: 'column', sm: 'row' }}
          w="full"
          space={Spacing['stack.nano']}
          borderRadius={BoxRadius.sm}
          alignItems="center"
          justifyContent="space-between">
          <Stack
            space={Spacing['inline.nano']}
            direction={{ base: 'row', sm: 'column' }}
            alignItems={{ base: 'center', sm: 'flex-start' }}
            justifyContent="space-between"
            w={{ base: 'full', sm: 'container' }}>
            <Text
              variant={fontVariant}
              fontSize={Typography['fontsize.md']}
              color="neutral.darkest">
              Clientes adicionados
            </Text>
            <HStack alignItems="center" space={Spacing['inline.nano']}>
              <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.black">
                {totalCustomers}
              </Text>
              <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.darkest">
                Clientes
              </Text>
            </HStack>
          </Stack>
          <VStack
            direction={{ base: 'row', sm: 'column' }}
            w={{ base: 'full', sm: 'container' }}
            justifyContent="space-between"
            space={Spacing['inline.quarck']}>
            <Text
              variant={fontVariant}
              fontSize={Typography['fontsize.md']}
              color="neutral.darkest">
              Saldo total disponível
            </Text>
            <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {totalAvailableBalanceFormatted}
            </Text>
            {!isMobile && (
              <Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.medium">
                {updatedDateFormatted}
              </Text>
            )}
          </VStack>
          <Stack
            space={Spacing['inline.nano']}
            direction={{ base: 'row', sm: 'column' }}
            alignItems={{ base: 'center', sm: 'flex-start' }}
            justifyContent="space-between"
            w={{ base: 'full', sm: 'container' }}>
            <Text
              variant={fontVariant}
              fontSize={Typography['fontsize.md']}
              color="neutral.darkest">
              Ativos adicionados
            </Text>
            <HStack alignItems="center" space={Spacing['inline.nano']}>
              <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.black">
                {totalOffers}
              </Text>
              <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.darkest">
                Ativos
              </Text>
            </HStack>
          </Stack>
          <VStack
            direction={{ base: 'row', sm: 'column' }}
            w={{ base: 'full', sm: 'container' }}
            justifyContent="space-between"
            space={Spacing['inline.quarck']}>
            <Text
              variant={fontVariant}
              fontSize={Typography['fontsize.md']}
              color="neutral.darkest">
              Total do Investimento
            </Text>
            <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {totalAmountFormatted}
            </Text>
            {!isMobile && (
              <Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.medium">
                {totalOffersByMarket} Produtos selecionados
              </Text>
            )}
          </VStack>
        </Stack>
      </Stack>
    </VStack>
  );
};
